import Vue from 'vue';

/**
 * The global event bus should be used with care and only if it can't be solved with Vuex.
 * see https://vuejs.org/v2/style-guide/#Non-flux-state-management-use-with-caution
 */
const EVENT_BUS_INSTANCE = new Vue();

export {
  EVENT_BUS_INSTANCE
};
